import type { StoredStage } from "./stageRecord.js";

export const STAGE_STORE_KEY = "stage-maker.v1";

export type MemoryStorage = { getItem(key: string): string | null; setItem(key: string, value: string): void };

export function readStore(storage: MemoryStorage): Record<string, StoredStage> {
  try {
    const raw = storage.getItem(STAGE_STORE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as Record<string, StoredStage>;
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function writeStage(storage: MemoryStorage, stage: StoredStage): Record<string, StoredStage> {
  const next = { ...readStore(storage), [stage.id]: stage };
  storage.setItem(STAGE_STORE_KEY, JSON.stringify(next));
  return next;
}

export function getStage(storage: MemoryStorage, id: string): StoredStage | undefined {
  return readStore(storage)[id];
}
